import * as actionType from '../constants/constant.action'

const defaultState = {}

const memberDetailReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_MEMBER_DETAIL_REQUESTED:
      return {
        ...state,
      }

    case actionType.GET_MEMBER_DETAIL_SUCCESS:
      if (action.payload.response && action.payload.response.status === 500) {
        return {
          ...action.payload,
          serverError: true,
        }
      }
      return {
        ...action.payload,
      }

    case actionType.GET_MEMBER_DETAIL_FAILURE:
      return {
        loading: false,
        serverError: true,
      }

    case actionType.SORT_BY_MEMBER_DETAIL: {
      return {
        ...action.payload,
      }
    }

    case actionType.MEMBER_SEARCH_EMPTY: {
      return defaultState
    }

    default:
      return state
  }
}

export default memberDetailReducer
